<template>
  <div class="content">
    <div class="container-fluid">
      <div class="row">
        <reload frase="Estamos Processando seu envio, Aguarde um momento!"  v-if="reload_hab"></reload>

        <div class="col-xl-3 col-md-6">
          <router-link to="espera">
            <stats-card3>
              <div slot="header" class="icon-danger">
                <i class="nc-icon nc-time-alarm text-white"></i>
              </div>
              <div slot="content">
                <p class="card-category">Manifestações em Espera</p>
                <h4 class="card-title">{{manifestacao_espera.length}}</h4>
              </div>
              <div slot="footer">
                <router-link to="espera" style="color: #fff"><i class="fa fa-clock-o"></i>Visualizar</router-link>
              </div>
            </stats-card3>
          </router-link>
        </div>

        <div class="col-xl-3 col-md-6">
          <router-link to="minhasmanifestacoes">
            <stats-card4>
              <div slot="header" class="icon-success">
                <i class="nc-icon nc-notes text-white"></i>
              </div>
              <div slot="content">
                <p class="card-category">Minhas Manifestações</p>
                  <h4 class="card-title">{{manifestacao_exibir.length}}</h4>
              </div>
              <div slot="footer">
                <router-link to="minhasmanifestacoes" style="color: #fff "><i class="fa fa-eye"></i>Visualizar</router-link>
              </div>
            </stats-card4>
          </router-link>
        </div>

        <div class="col-xl-3 col-md-6">
          <router-link to="perfil">
              <stats-card2>
                <div slot="header" class="icon-warning">
                  <i class="nc-icon nc-single-02 text-white"></i>
                </div>
                <div slot="content">
                  <p class="card-category">Meu Perfil</p>
                  <h4 class="card-title"></h4>
                </div>
                <div slot="footer">
                  <router-link to="perfil" style="color: #fff"><i class="fa fa-eye"></i>Visualizar</router-link>
                </div>
              </stats-card2>
          </router-link>  
        </div>
      </div>
      <div class="col-md-12" v-if="msgAlterada" style="padding-left: 0px;padding-right: 0px;">
          <div
              class="card"
              style="background-color: rgb(50 170 159) !important;color: #fff !important;margin-bottom: 20px !important;"
              v-if="msg==1"
          >
              <div class="card-body">
                <div class="row">
                  <div class="col-md-12">{{msgAlterada}}</div>
                </div>
              </div>
          </div>
          <div
              class="card"
              style="background-color: rgb(170 72 50) !important;color: #fff !important;margin-bottom: 20px !important;"
              v-if="msg==0"
          >
              <div class="card-body">
                <div class="row">
                  <div class="col-md-12">{{msgAlterada}}</div>
                </div>
              </div>
          </div>
          <div
              class="card"
              style="background-color: rgb(191 187 54) !important;color: #fff !important;margin-bottom: 20px !important;"
              v-if="msg==2"
          >
              <div class="card-body">
                <div class="row">
                  <div class="col-md-12">{{msgAlterada}}</div>
                </div>
              </div>
          </div>
      </div>      

      <div class="">
          <card class="col-md-12 padding-zero-top" >
            <h4 slot="header" class="card-title m-cidadao">Manifestar-se</h4>
            <form>
              <div class="row">
                <div class="col-md-6 padding-zero-top">
                  <div class="form-group">
                    <label for="sel1">Tipo:</label>
                    <select class="form-control" id="tipo" name="tipo" v-model="manifesto.tipo">
                      <option v-for="a in tiposAssunto" :key="a.id" :value="a.nome">
                      {{ a.nome }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>
              
              <div class="row">
                <div class="col-md-12 padding-zero-top">
                    <label>Assunto:</label><br>
                    <label for="sel1" class="manif-tipo-color">Sobre qual assunto você quer falar?</label>
                    <input
                      type="text"
                      placeholder="Assunto"
                      maxlength="250"
                      v-model="manifesto.assunto"
                      v-on:blur="validacaoAssunto(manifesto.assunto)"
                      class="form-control"
                      :style="styleAssunto"
                    />
                    <div v-if="assuntoverify==0">
                        <label
                          class="control-label"
                          v-if="styleAssunto!=''"
                          style="color:rgb(243 0 0);font-size: 12px;"
                        >*Obrigatorio</label>
                    </div>
                    <label
                      class="control-label"
                      v-if="assuntoverify==1"
                      style="color:rgb(183 179 55);font-size: 12px;"
                    >* Minimo 6 caracteres</label>
                </div>
              </div>
              <div class="row" style="margin-top: 20px;">  
                <div class="col-md-12 padding-zero-top">
                  <div class="form-group">
                    <label for="descricao">Descrição:</label><br>
                    <label class="manif-tipo-color"> Descreva abaixo o que deseja.
                       Seja claro e objetivo. Não utilize o campos abaixo para
                        informações pessoais, só informe dados que são essenciais
                         para a caracterização da manifestação.
                    </label>
                      <textarea
                        class="form-control"
                        rows="5"
                        id="descricao"
                        name="descricao"
                        v-model="manifesto.descricao"
                        v-on:blur="validacaoDescricao(manifesto.descricao)"
                        :style="styleDescricao"
                        maxlength="1000"
                      ></textarea>
                      <label class="control-label" v-if="manifesto.descricao != null">{{
                        manifesto.descricao.length
                      }}</label
                      >
                      <div v-if="descricaoverify==0">
                        <label
                          class="control-label"
                          v-if="styleDescricao!=''"
                          style="color:rgb(243 0 0);font-size: 12px;"
                        >*Obrigatorio</label>
                      </div>
                      <label
                        class="control-label"
                        v-if="descricaoverify==1"
                        style="color:rgb(183 179 55);font-size: 12px;"
                      >* Minimo 30 caracteres</label>
                    
                  </div>
                </div>
              </div>
              <div v-if="manifesto.tipo!='Elogio'">
                <div class="row">  
                  <div class="col-md-12 padding-zero-top">
                    <h4 class="m-cidadao" >Local da Ocorrência</h4>
                  </div>  
                </div>    
                <div class="row" style="margin-top: 20px;">
                  <div class="col-md-10 padding-zero-top">
                    <base-input type="text"
                              id="rua"
                              name="rua"
                              label="Rua"
                              placeholder="Rua"
                              v-model="manifesto.rua"
                              maxlength="150">
                    </base-input>  
                  </div>
                  <div class="col-md-2 padding-zero-top">
                    <base-input type="number"
                              id="numero"
                              name="numero"
                              label="Número"
                              placeholder="Número"
                              v-model="manifesto.numero"
                              maxlength="150">
                    </base-input>  
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-7 padding-zero-top">
                    <base-input type="text"
                              id="complemento"
                              name="complemento"
                              label="Complemento"
                              placeholder="Complemento"
                              v-model="manifesto.complemento"
                              maxlength="150">
                    </base-input>  
                  </div>
                  <div class="col-md-5 padding-zero-top">
                    <base-input type="text"
                              id="bairro"
                              name="bairro"
                              label="Bairro"
                              placeholder="Bairro"
                              v-model="manifesto.bairro"
                              maxlength="150">
                    </base-input>  
                  </div>
                </div>
              </div>

              

              <div class="" style="padding-top:20px;padding-bottom:20px;">
                <label class="form-check-label">
                  <input type="checkbox" v-model="manifesto.sigilo" value="1">  Colocar manifestação em Sigilo
                </label>
              </div>
              <div class="text-center">
                <button type="submit" class="btn btn-primary btn-fill float-left" @click.prevent="manifestoCadastrar" v-if="desativar==0">  
                  Cadastrar Manifestação
                </button>
                <button type="submit" class="btn btn-primary btn-fill float-left" disabled v-if="desativar==1">  
                  Cadastrar Manifestação
                </button>
              </div>
              <div class="clearfix" style="margin-bottom:20px"></div>
            </form>
          </card>
      </div>
    </div>
  </div>
</template>
<script>

  import Reload from 'src/components/Reload-v1.vue'
  import ChartCard from 'src/components/Cards/ChartCard.vue'
  import StatsCard from 'src/components/Cards/StatsCard.vue'
  import StatsCard2 from 'src/components/Cards/StatsCard2.vue'
  import StatsCard3 from 'src/components/Cards/StatsCard3.vue'
  import StatsCard4 from 'src/components/Cards/StatsCard4.vue'
  import LTable from 'src/components/Table.vue'

  import axios from 'axios';
  import store from "src/store.js"
  import store_cidadao from "src/storeCidadao.js"
  import 'src/controller/cidadao/cidadaoController.js'
  import 'src/controller/site/homeController.js'
  import 'src/controller/loginController.js'
  import "src/controller/tiposController.js";

  export default {
    components: {
      Reload,
      LTable,
      ChartCard,
      StatsCard,
      StatsCard2,
      StatsCard3,
      StatsCard4
    },
    data () {
      return {
        reload_hab: false,
        desativar:0,
        espera:0,
        manifesto:{
          tipo:"Reclamação",
          secretaria:1,
          assunto:null,
          descricao:null,
          rua:null,
          numero:null,
          bairro:null,
          complemento:null,
          sigilo:0,
        },
        msgAlterada: null,
        msg: null,
        assuntoverify:0,
        descricaoverify:0,
        styleAssunto:"",
        styleDescricao:"",
        verify_assunto:false,
        verify_descricao:false,
        me:0,
        assuntos:[],
        secretarias:[],
        tiposAssunto:[],
        result:[],
        manifestacao:null,
        manifestacao_exibir:[],
        manifestacao_espera:[],
      }
    },
    methods: {
        /*async buscarSecretaria(){
          try{
            let data = await this.$secretaria();
            this.secretarias = data.data;
          }catch(e){

          }  
        },*/
        async listarTAssunto(){
          try {
            let data = await this.$listarTiposAssunto();
            this.tiposAssunto = data.data;
          } catch (e) {
            
          }
        },
        validacaoAssunto(assunto){
        if (assunto) {
          this.msgAlterada = "";
          this.styleAssunto ="";
          this.styleDescricao="";

          if (assunto.length <= 5) {
            this.msgAlterada =
              "O campo Assunto deve possuir no minimo 6 Caracteres!";
            this.msg = 2;
            this.assuntoverify =1;
            this.verify_assunto = false;
            return false;
          } else {
            this.msgAlterada = "";
          }

          this.assuntoverify =0;
          this.verify_assunto = true;
        } else {
          this.styleAssunto = "border: 2px solid rgb(243 0 0);";
          this.msgAlterada = "O campo Assunto está Vazio!";
          this.msg = 0;
          this.assuntoverify =0;
          this.verify_assunto = false;
          return false;
        }
      },
      validacaoDescricao(descricao){
        if (descricao) {
          this.msgAlterada = "";
          this.styleAssunto ="";
          this.styleDescricao="";

          if (descricao.length <= 30) {
            this.msgAlterada =
              "O campo Descrição deve possuir no minimo 30 Caracteres!";
            this.msg = 2;
            this.descricaoverify =1;
            this.verify_descricao = false;
            return false;
          } else {
            this.msgAlterada = "";
          }

          this.descricaoverify =0;
          this.verify_descricao = true;
        } else {
          this.styleDescricao = "border: 2px solid rgb(243 0 0);";
          this.msgAlterada = "O campo Descrição está Vazio!";
          this.msg = 0;
          this.descricaoverify =0;
          this.verify_descricao = false;
          return false;
        }
      },
      async manifestoCadastrar(){
        try {
          scroll(0, 50);
          this.msgAlterada ="";
          this.styleAssunto ="";
          this.styleDescricao="";

          if (this.manifesto.assunto == null || this.manifesto.assunto =="") {
            this.styleAssunto = "border: 2px solid rgb(243 0 0);";
            this.msgAlterada = "O campo Assunto está Vazio!";
            this.msg = 0;
            this.desativar = 0;
            return false;
          }

          if (this.manifesto.descricao == null || this.manifesto.descricao =="") {
            this.styleDescricao = "border: 2px solid rgb(243 0 0);";
            this.msgAlterada = "O campo Descricao está Vazio!";
            this.msg = 0;
            this.desativar = 0;
            return false;
          }
          if(this.verify_descricao && this.verify_assunto){
            this.desativar = 1;
            //ativar reload
            this.reload_hab = true;
            //cadastrar manifesto
            let data = await this.$manifestarIdCidadao(store_cidadao.id_cidadao,this.manifesto);
            let result = data.data;
            if (data.msg == "Campos Vazios!") {
              this.msgAlterada = data.msg;
              this.msg = 0;
              this.desativar = 0;
              this.reload_hab = false;
              return false;
            }
          
            if (data.msg == "Manifestação cadastrada com sucesso!") {
              this.msgAlterada = data.msg;
              this.msg = 1;
              this.desativar = 0;
              this.reload_hab = false;
              this.manifesto.tipo = "Reclamação";
              this.manifesto.secretaria = 1;
              this.manifesto.assunto = null;
              this.manifesto.descricao = null;
              this.manifesto.rua = null;
              this.manifesto.numero = null;
              this.manifesto.bairro = null;
              this.manifesto.complemento = null;
              this.manifestacao_espera = [];
              this.listarTudo();
            }
          }
        }catch (e) {
          //console.log(e);
          this.msgAlterada = "Ocorreu um erro inesperado, tente novamente!";
          this.msg = 0;
          this.desativar = 0;
        }
      },
      // funcoes para exibir quantas manifestaçoes estao em espera
      async listarTudo(){
        try {
          let data = await this.$listarManifestosCidadao(store_cidadao.id_cidadao);
          this.manifestacao_exibir = data.data;
          
          this.manifestacao_exibir.forEach(array => {
              this.filtro(array);
          });

        }catch(e){

        }
      },

      async filtro(array) {
         try {
            if(array.abertura == "Espera"){
              let manifesto={
                uuid: array.uuid,
                abertura:array.abertura,       
              };
              this.manifestacao_espera.push(manifesto);
              
            }
         } catch (error) {
           //console.log(error);
         }
      },
      
    },
    beforeMount(){
       try {
        this.listarTudo();
        this.listarTAssunto();
        //this.buscarSecretaria();   
       } catch (e) {
         
       }
    }

  }
</script>
<style>
   .text-white{
     color: #ffffff;
   }
   .m-cidadao{
     margin: 0px 0 0px !important;
   }
   .padding-zero-top{
     padding-top:0px !important;
   }
   .up-text-manif{
      margin-top: -11px;
   }
   .manif-tipo-color{
     color: #9a9a9a;
     font-style: italic;
     font-size: 13px;
     text-transform: none !important;
   }

  
</style>
